import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketAssetFinance } from './TicketAssetFinance.interface';
import TicketAssetFinanceAsset from './TicketAssetFinanceAsset';
import TicketAssetFinanceFinance from './TicketAssetFinanceFinance';

export default class TicketAssetFinance implements ITicketAssetFinance {
  id: string;
  vbi: boolean;
  vbiId: string;
  vehicleSelect: boolean;
  redBook: boolean;
  asset: TicketAssetFinanceAsset;
  finance: TicketAssetFinanceFinance;

  static build = (data: ITicketAssetFinance) => new TicketAssetFinance(data);
  static blank = () => new TicketAssetFinance({ id: uuid(), vbiId: uuid() });

  /**
   * Constructor
   * @param {ITicketAssetFinance} data
   */
  constructor(data?: ITicketAssetFinance) {
    this.id = toUUID(data?.id) || uuid();
    this.vbi = data?.vbi === true;
    this.vbiId = toUUID(data?.vbiId);
    this.vehicleSelect = data?.vehicleSelect === true;
    this.redBook = data?.redBook === true;
    this.asset = new TicketAssetFinanceAsset(data?.asset);
    this.finance = new TicketAssetFinanceFinance(data?.finance);
  }
}
